import { slideTransitionTypesVar } from '../../reference/transitions';

export const getAnimationIn = slide => {
  if (slide.transition.type === slideTransitionTypesVar.fadeOut) return `${slideTransitionTypesVar.none}-in`;
  if (slide.transition.type !== slideTransitionTypesVar.fadeIn) return `${slide.transition.type}-in`;
  return slideTransitionTypesVar.fadeIn;
};
